/* eslint-disable camelcase */
import {
  SsoRuleToCreate,
  SsoRuleToUpdate,
  SsoOrganization,
  SsoRule,
} from '@robocorp/robocloud-sso-management-interface';
import { ssoManagementApi } from '~/utils/api';

export const createRule = async (options: { realm: string }, payload: SsoRuleToCreate) =>
  ssoManagementApi.post<SsoRuleToCreate>(`/realm/${options.realm}/rbac-rules`, payload);

export const editRule = async (options: { realm: string }, payload: SsoRuleToUpdate) =>
  ssoManagementApi.put<SsoRuleToUpdate>(
    `/realm/${options.realm}/rbac-rules/${payload.id}`,
    payload,
  );

export const deleteRule = async (options: { realm: string; ruleId: string }) =>
  ssoManagementApi.delete<void>(`/realm/${options.realm}/rbac-rules/${options.ruleId}`);

export const getRules = async (options: { realm: string }) =>
  ssoManagementApi.get<SsoRule[]>(`/realm/${options.realm}/rbac-rules`);

export const getOrganizations = async (options: { realm: string }) =>
  ssoManagementApi.get<SsoOrganization[]>(`/realm/${options.realm}/organizations`);

export const createSsoWorkspace = async (options: {
  realm: string;
  organizationId: string;
  workspaceName: string;
  isAgentWorkspace: boolean;
}) => {
  const payload = {
    workspaceName: options.workspaceName,
    isAgentWorkspace: options.isAgentWorkspace,
  };

  return ssoManagementApi.post<void>(
    `/realm/${options.realm}/organizations/${options.organizationId}/workspaces`,
    payload,
  );
};
